const dateFormater = (data) => {
  if (!data) {
    return '';
  }
  const date = new Date(data);
  return date.toLocaleDateString('uk', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

const barcodeFormater = (rowData) => {
  const { products = [] } = rowData;
  const result = products.map(({ barcode }) => barcode).join(', ');
  return result;
};

const productFormater = (rowData) => {
  const { products = [], capacity } = rowData;
  const result = products.map(({ product }) => product.title).join(', ');
  return `${capacity}м³ / ${result}`;
};

const lengthFormater = (rowData) => {
  const { products = [] } = rowData;
  const result = products.map(({ length }) => `${length}м.`).join(', ');
  return result;
};

export const formatedItemsExport = (arrItems, role) => {
  const result = arrItems.map((item) => {
    return {
      ...(['admin']?.includes(role) ? { 'Підриємство ': item?.company_name ?? '' } : {}), //company_name
      'Бирки №': item?.barcode ?? '',
      'Продукція ': item?.product, //product
      'Склад ': item?.storage ?? '', //storage
      'Об`єм в м³': item?.capacity ?? '', //capacity
      'Довжина ': item?.length, //length
      'Приймання №': item?.document_no ?? '', //document_no
      'Постачальник ': item?.supplier ?? '', //supplier
      'Перевізник ': item?.carrier ?? '', //carrier
      'Дата крайньої інвентарізації': item?.date_inventory, //date_inventory
      'Історія інвентарізацій': item?.date_inventory_history, //date_inventory_history
      // ...(['admin']?.includes(role) ? { 'Користувач ': item?.user?.title ?? '' } : {}), //user
    };
  });
  return result;
};
